export class TypeFournitures {

	public location: string;

	public achat: string;

	public creditBail: string;

	public locationVente: string;

	constructor() {
		 		this.location = '';
		this.achat = '';
		this.creditBail = '';
		this.locationVente = '';

	}
}
